/**
 * Where a sample plays from (2026-11-02, the user: "preview of artists samples should come from SoundCloud — best
 * track from each artist"). A SoundCloud track plays in full (else its 30-second preview, 2026-11-03) through the API
 * (`/samples/soundcloud/<user>/<track>`, a redirect to SoundCloud's address of the moment — it expires in minutes, so
 * it is never kept); any other address — the raves' own files — is OFF for now (`OLD_SAMPLES_PLAY`, the user
 * 2026-11-02: "disable the old samples for now"), else played as it is through `webHref` (http(s) only).
 */
import { OLD_SAMPLES_PLAY, soundcloudProfileUser, soundcloudSamplePath, webHref } from '@myrave/shared';
import { apiUrl } from './tenant.js';

export function sampleSrc(audioUrl: string | null | undefined): string | undefined {
  // A track, or the artist's PROFILE while its best track is still to be found — the API finds and saves it then.
  const path = soundcloudSamplePath(audioUrl) ?? soundcloudProfileUser(audioUrl);
  if (path) return `${apiUrl()}/samples/soundcloud/${path}`;
  // The raves' own files are off for now (2026-11-02) — a lineup kept on the phone from before still names them.
  return OLD_SAMPLES_PLAY ? webHref(audioUrl) : undefined;
}

/** A sample the API plays from SoundCloud: its `?info=1` address (title and page), else null. */
export function soundcloudInfoOf(src: string): string | null {
  return /\/samples\/soundcloud\/[\w-]+(\/[\w-]+)?$/.test(src) ? `${src}?info=1` : null;
}

/** The SoundCloud page of a sample the API plays — the player credits and links it (SoundCloud's API terms). */
export function soundcloudPageOf(src: string): string | null {
  const m = /\/samples\/soundcloud\/([\w-]+(?:\/[\w-]+)?)$/.exec(src);
  return m ? `https://soundcloud.com/${m[1]}` : null;
}
